import { getDefaultConfig, WalletList } from "@rainbow-me/rainbowkit";
import {
  coinbaseWallet,
  coreWallet,
  okxWallet,
  rabbyWallet,
  safeWallet,
  trustWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import once from "lodash/once";
import { Chain, http } from "viem";

import {
  botanix,
  assetChain,
  assetChainTestnet,
  arbitrum,
  base,
  baseSepolia,
  polygon,
  arbitrumSepolia,
  bsc,
  bscTestnet,
  bitlayer,
  bitlayerTestnet,
} from "config/chains";
import { isDevelopment } from "config/env";

import binanceWallet from "./connecters/binanceW3W/binanceWallet";
import { metaMaskWalletFixed } from "./metaMaskWalletFixed";

const WALLET_CONNECT_PROJECT_ID = "de24cddbaf2a68f027eae30d9bb5df58";
const APP_NAME = "Nectarliquid";

const popularWalletList: WalletList = [
  {
    // Group name with standard name is localized by rainbow kit
    groupName: "Popular",
    wallets: [
      rabbyWallet,
      metaMaskWalletFixed,
      okxWallet,
      walletConnectWallet,
      // The Safe option will only appear in the Safe Wallet browser environment.
      safeWallet,
    ],
  },
];

const othersWalletList: WalletList = [
  {
    groupName: "Others",
    wallets: [binanceWallet, coinbaseWallet, trustWallet, coreWallet],
  },
];

export const getRainbowKitConfig = once(() =>
  getDefaultConfig({
    appName: APP_NAME,
    projectId: WALLET_CONNECT_PROJECT_ID,
    // Avoid duplicate EIP-6963 connectors from wagmi that can overlap RainbowKit entries.
    multiInjectedProviderDiscovery: false,
    chains: [
      botanix as Chain,
      assetChain as Chain,
      arbitrum as Chain,
      base as Chain,
      baseSepolia as Chain,
      polygon as Chain,
      arbitrumSepolia as Chain,
      bsc as Chain,
      bscTestnet as Chain,
      bitlayer as Chain,
      bitlayerTestnet as Chain,
      ...(isDevelopment() ? [assetChainTestnet as Chain] : []),
    ],
    transports: {
      [botanix.id]: http(),
      [assetChain.id]: http(),
      [arbitrum.id]: http(),
      [base.id]: http(),
      [baseSepolia.id]: http(),
      [polygon.id]: http(),
      [arbitrumSepolia.id]: http(),
      [bsc.id]: http(),
      [bscTestnet.id]: http(),
      [bitlayer.id]: http(),
      [bitlayerTestnet.id]: http(),
      [assetChainTestnet.id]: http(),
    },
    wallets: [...popularWalletList, ...othersWalletList],
  })
);
